import { FileUploadResponse } from '../../../../api/core'
import { Setting } from '../../../../types/Setting'

export type GameStoreRef = { id: string; name?: string }
export type GameMarketRef = { id: string; name?: string; iso?: string }

type InternalGameFields = {
  id?: string
  name?: string
  desc?: string
  icon?: FileUploadResponse | string | null
  // Store icon URLs; most games have these and no `icon`.
  icons?: string[] | null
  artist?: string | null
  appId?: number | null
  platforms?: string[] | null
  conventionalSubgenre?: string | null
  overrideConventionals?: boolean
  genreInnovator?: number | null
  archive?: boolean
  stageId?: number | null
  stage?: string | null
  softLaunchMarket?: string | null
  stores?: GameStoreRef[] | null
  markets?: GameMarketRef[] | null
  genre?: string | null
  subGenre?: string | null
  reviewId?: string | null
  reviewPublished?: boolean | null
  // Market iso → store link.
  storeLinks?: Record<string, string> | null
  analysisOutdated?: boolean | null
}

// `GET i/games/{id}` as stored. A save sends the whole document back, so unknown keys are kept.
export type InternalGameDocument = InternalGameFields & { [key: string]: unknown }

// What `PUT i/games/{id}` and `POST i/games` take: stores and markets as ids.
export type InternalGameMutation = Omit<InternalGameFields, 'stores' | 'markets'> & { stores: string[]; markets: string[]; [key: string]: unknown }

export type GamePosition = {
  id: string
  storeId: string
  storeName: string
  marketId: string
  marketIso: string
  marketName: string
  fullName: string
}

export type EditGameFormValues = {
  name: string
  desc: string
  icon: FileUploadResponse | string | null
  artist: string
  appId: string
  analystId: string
  platforms: string[]
  conventionalSubgenre: string
  overrideConventionals: boolean
  // '' while a new game has none, as legacy leaves it out.
  genreInnovator: number | ''
  archive: boolean
  stageId: number | ''
  softLaunchMarket: string
  positionIds: string[]
}

export type GameAnalystMap = Record<string, string>
export type GameAnalystMapSetting = Setting<GameAnalystMap>

export enum AnalyzedFilter {
  Analyzed = 'analyzed',
  NotAnalyzed = 'not-analyzed',
  All = 'all',
}

export const allMarketsIso = 'all'
